<div *ngIf="notesLst && notesLst.length > 0">
    <div class="m-4">
        <button mat-flat-button [color]="'primary'" class="m-r-10" (click)="addNewNote()">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:plus-circle'"></mat-icon>
            <span class="sm:inline-block ml-2">Note</span>
        </button>
    </div>
    <ds-loading *ngIf="loader === true"></ds-loading>
    <div class="flex flex-col w-full  m-2 cntntBgrnd">
        <div class="relative flex flex-col   flex-0 ng-tns-c266-4 ">
            <div class="grid grid-cols-1  sm:grid-cols-2 lg:grid-cols-4  w-full">
                <div *ngFor="let n of notesLst" class=" m-2 shadow p-4 bg-white rounded-lg ">
                    <div class="m-2">
                        <mat-icon class="icon-size-4 cursor-pointer" style="float: right;"
                            [svgIcon]="'heroicons_solid:pencil-alt'" (click)="edtNte(n)"></mat-icon>
                    </div>
                    <div class="font-medium p-1">{{n.nte_tx}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
